//import SecureLS from "secure-ls";

const isProduction = process.env.NODE_ENV === 'production';

/*
const secure = {
  encodingType: 'des', 
  isCompression: false, 
  encryptionSecret: 'VD{F(Nv(2]z=2cBg#2Qs'
}
*/

export const ChangeLocalState = (name: string, key:string, value:string | number | boolean | object) => {

  if ( !isProduction ) {
    window.localStorage.setItem(name, JSON.stringify({
      ...JSON.parse(GetLocalState(name)),
      [key]: value
    }));
  }
  else {

    window.localStorage.setItem(name, JSON.stringify({
      ...JSON.parse(GetLocalState(name)),
      [key]: value
    }));
    //var ls = new SecureLS(secure);
    //    ls.set(name, JSON.stringify(state)); 

  }
  
};

export const SetLocalState = (name: string, state:object) => {

  if ( !isProduction ) {
    window.localStorage.setItem(name, JSON.stringify(state));
  }
  else {

    window.localStorage.setItem(name, JSON.stringify(state));
    //var ls = new SecureLS(secure);
    //    ls.set(name, JSON.stringify(state)); 

  }
  
};

export const GetLocalState = (name:string) => {

  const data = window.localStorage.getItem( name );

  if ( !data ) return;

  if ( !isProduction ) {
    return JSON.parse(data);
  }
  else {

    return JSON.parse(data);
    //var ls = new SecureLS(secure);
    //    ls.get(name); 

    //return JSON.parse(ls.get(name));

  }

};